import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
    :root {
        // global variables
        --red: #FF0102;
        --black: #080808;
        --white: #fff;
        --grey: #777;

        --container: 950px;
    }

    html {
        box-sizing: border-box;
    }

    *,
    *::after,
    *::before {
        margin: 0;
        padding: 0;
        box-sizing: inherit;
    }

    body {
        background-image: url(${({ siteBgImage }) => siteBgImage});
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        background-attachment: fixed;
    }

    h1 {
        margin: 0;
    }

    p {
        margin-bottom: 1.5rem;
    }

    // Remove figure margin
    figure {
        margin: 0;
    }

    // Links
    a {
        color: var(--red);
        text-decoration: none;
        transition: color .3s;

        &:active,
        &:focus {
            color: var(--grey);
        }
    }

    // Selection styles
    ::selection {
        background-color: var(--red);
        color: var(--white);
    }

    // global button styles
    button,
    .button {
        background: var(--red);
        color: var(--white);
        border: 0;
        padding: 0.6rem 1rem;
        border-radius: .3rem;
        cursor: pointer;
        text-shadow: 0.5px 0.5px 0 rgba(0,0,0,0.2);
        font-size: 1.4rem;
        letter-spacing: .15rem;
        text-transform: uppercase;
        transition: all 0.2s;
        &:hover {
            background: #8F0002;
        }
    }

    .heading {
        text-align: center;
        padding: 2.5rem 0;
        font-family: HammersmithOne;
        font-size: 3.5rem;
        text-transform: uppercase;
        letter-spacing: .15rem;
        @media (max-width: 650px) {
            font-size: 1.7rem;
        }
    }

    .center {
        text-align: center;
    }

    .underline {
        width: 5rem;
        height: 0.5rem;
        margin-bottom: 1.25rem;
        background: var(--red);
        margin-left: auto;
        margin-right: auto;
        border-radius: 35%;
    }

    // Snipcart styles
    .snipcart-modal__container button:hover {
        background-color: rgba(0, 0, 0, .3);
        transition: background-color .2s ease;
    }

    .snipcart-cart-header__close-button:hover,
    .snipcart-cart-header__option:hover {
        background-color: initial !important;
    }

    .snipcart-cart-button--highlight:hover {
        background: linear-gradient(90deg, #5082e4, #52bcf8);
    }

    .snipcart-cart-button--secondary:hover {
        background-color: initial !important;
        box-shadow: 0 5px 10px rgba(0, 0, 0, .15);
    }

    // Keyframes
    @keyframes fade-in {
        to {
            opacity: 1;
        }
    }
`;

export default GlobalStyles;